var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommends"},[_vm._l((_vm.recommends),function(item,index){return _c('Pc-recommend-list-item',{key:index,attrs:{"recommend-item":item}})}),_vm._v(" "),_c('div',{staticStyle:{"color":"grey","font-size":"small","height":"80px","display":"flex","align-items":"center","justify-content":"center"}},[_vm._v("暂无更多~")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59985693","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/PcRecommendList.vue
// module id = null
// module chunks = 